/**
 * Copyright (C) IRT GmbH 2020
 */

 var test_urls = [
    "https://mcdn.br.de/aoip/20-12-12/st_mix_1212_1000_dash_mp4box/st_mix_1212_1000_dash.mpd",
    "https://mcdn.br.de/aoip/20-12-12/st_dp1_1212_1000_dash_mp4box/st_dp1_1212_1000_dash.mpd",
    "https://mcdn.br.de/aoip/20-12-12/st_dp3_1212_1000_dash_mp4box/st_dp3_1212_1000_dash.mpd",
    "https://mcdn.br.de/aoip/20-12-15/st_mix_1215_1530_dash_mp4box/st_mix_1215_1530_dash.mpd"
 ];

 var test_urlsMP4 = [
    "https://mcdn.br.de/aoip/20-12-12/st_mix_1212_1000.mp4",
    "https://mcdn.br.de/aoip/20-12-12/st_dp1_1212_1000.mp4",
    "https://mcdn.br.de/aoip/20-12-12/st_dp3_1212_1000.mp4",
    "https://mcdn.br.de/aoip/20-12-15/st_mix_1212_1530.mp4"
 ];

 var test_stream = {
   "name": "st_mix",
    "target": [
        "SMARTPHONE",
        "MULTISTREAM"
    ],
    "serviceType": "DIALOGPLUS",
    "type": "AUDIO",
    "title": "Sendeton",
    "id": "slave_13:3021.09#00_0",
    "timelineSpec": "urn:dvb:css:timeline:mpd:period:rel:1000",
    "mimeType": "application/dash+xml",
    "available": true,
    "start": 41454.636,
    "timescale": 1000
};

 module.exports = function (debug) {
    return function (json) {
        var json_available = {
            eventid : json.eventid,
            svcName : json.svcName,
            master : json.master,
            companionstreams : []
        };
        for (x in json.companionstreams) {
            var stream = json.companionstreams[x];
            if (stream.available) {
                json_available.companionstreams.push(stream);
            }
        }
        if (debug && json_available.companionstreams.length == 0) {
            try {
                test_stream.start = json_available.master.start;
                for (x=0; x<test_urls.length; x++) {
                    var s = JSON.parse(JSON.stringify(test_stream));
                    s.id   = "slave_" + json_available.eventid + "_" + x;
                    s.url  = test_urls[x];
                    s.title = "TEST/DEBUG " + (x+1);
                    s.urlMP4 = test_urlsMP4[x];
                    json_available.companionstreams.push(s);
                }
            } catch (e) {
            }
        }
        return json_available;
    };
}
